export default {
    props: {
        tileSizeWidth: {
            type: Number,
            kComposite: 'tileSize.width'
        }, 
        tileSizeHeight: {
            type: Number,
            kComposite: 'tileSize.height'
        }
    }
}


// WEBPACK FOOTER //
// ./packages/kendo-inputs-vue-wrapper/src/Common/TileSize.js